const initSubmitSearch = () => {
    // const showData is grabbed from page
    // const releaseData is grabbed from page
    const shows = showData.shows;
    const releases = releaseData.releases;

    const searchInputs = document.querySelectorAll('.js-search');

    // Only way I could find to decode html entities was this...
    const decodeHtmlEntities = (str) => {
        const txt = document.createElement('textarea');
        txt.innerHTML = str;
        return txt.value;
    };

    const formatDate = (dateStr) => {
        if (!dateStr) return null;
        const year = dateStr.slice(0, 4);
        const month = dateStr.slice(4, 6);
        const day = dateStr.slice(6, 8);
        const date = new Date(`${year}-${month}-${day}T00:00:00`);
        if (isNaN(date.getTime())) return null;
        return date.toLocaleDateString('en-GB', {
            weekday: 'long',
            year: 'numeric',
            month: 'long',
            day: 'numeric',
        });
    };

    const createShowCard = (show) => {
        const card = document.createElement('div');
        card.className = 'submit-show-card js-card';
        card.dataset.id = show.id;
        card.dataset.name = `${decodeHtmlEntities(show.title)} ${show.location}`;
        const formattedDate = formatDate(show.date);
        card.dataset.date = formattedDate;

        card.innerHTML = `
        <div class='submit-show-card__media-wrap'>
            ${show.imageUrl ? `<img src='${show.imageUrl}' alt=''>` : ''}
        </div>
        <div class='submit-show-card__content'>
            ${formattedDate ? `<strong>${formattedDate}</strong>` : ''}
            <p>
                ${show.title}
                ${show.location ? `<br>${show.location}` : ''}
            </p>
        </div>
    `;

        return card;
    };

    const createReleaseCard = (release) => {
        const card = document.createElement('div');
        card.className = 'submit-release-card js-card';
        card.dataset.id = release.id;
        card.dataset.name = release.title;

        card.innerHTML = `
        <div class='submit-release-card__media-wrap'>
            ${release.imageUrl ? `<img src='${release.imageUrl}' alt=''>` : ''}
        </div>
        <div class='submit-release-card__content'>
            <p>${release.title}</p>
        </div>
    `;

        return card;
    };

    searchInputs.forEach((input) => {
        const resultsContainer =
            input.parentNode.querySelector('.js-post-selection');
        const { type } = input.dataset;

        input.addEventListener('input', (e) => {
            const query = e.target.value.toLowerCase();
            const queryWords = query.split(/\s+/);
            let results = [];

            if (query && query.length > 1) {
                if (type === 'show') {
                    results = shows.filter((show) => {
                        const title = show.title.toLowerCase();
                        const location = show.location.toLowerCase();

                        return queryWords.every(
                            (word) =>
                                title.includes(word) || location.includes(word),
                        );
                    });
                } else if (type === 'release') {
                    results = releases.filter((release) => {
                        const title = release.title.toLowerCase();

                        return queryWords.every((word) => title.includes(word));
                    });
                }
            }

            resultsContainer.innerHTML = '';
            results.forEach((item) =>
                resultsContainer.appendChild(
                    type === 'show' ? createShowCard(item) : createReleaseCard(item),
                ),
            );
        });
    });
};

export default initSubmitSearch;
